import { B3_PUBLIC_RPC } from "../../../anyspend/constants/rpc.js";
import { b3 as viemB3 } from "viem/chains";
/**
 * Viem's built-in `b3` chain points at mainnet-rpc.b3.fun; we spread it and override
 * RPC URLs so all SDK call sites stay aligned with {@link B3_PUBLIC_RPC}.
 */
export const b3Viem = {
    ...viemB3,
    rpcUrls: {
        ...viemB3.rpcUrls,
        default: {
            ...viemB3.rpcUrls.default,
            http: [B3_PUBLIC_RPC],
        },
    },
};
